import { z } from 'zod';
/** Shared scalar shapes. Every id in the system is a v4 uuid. */
export const uuid = z.string().uuid();
export const email = z.string().email().max(320);
export const isoDateTime = z.string();
/** A slug: lowercase, digits, single hyphens, no leading/trailing hyphen. */
export const slug = z
    .string()
    .min(1)
    .max(96)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'must be a lowercase hyphenated slug');
export const markdown = z.string().max(200_000);
export const shortText = z.string().max(512);
export const mediumText = z.string().max(4_000);
export const paginationQuery = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export function page(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int(),
        limit: z.number().int(),
        offset: z.number().int(),
    });
}
/** Every non-2xx response from the API has this body. */
export const apiErrorBody = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Present on 403s: why the caller is not allowed, in words a human can act on. */
        reason: z.string().optional(),
        details: z.unknown().optional(),
    }),
});
export const reorderRequest = z.object({
    /** Ids in their new order. Must be exactly the ids of the collection. */
    order: z.array(uuid).min(1),
});
export const publishStatus = z.enum(['draft', 'published']);
export const courseStatus = z.enum(['draft', 'published', 'archived']);
export const globalRole = z.enum(['admin', 'member']);
//# sourceMappingURL=primitives.js.map